import styles from './slideshow.module.scss'

import React from 'react'

export default class Slideshow extends React.Component {
  constructor(props) {
    super(props)

    this._timeout = null

    this.state = {
      slide: 0,
    }
  }

  _showSlide(index) {
    if (this._timeout) {
      clearTimeout(this._timeout)
    }

    this.setState({ slide: index })

    if (this.props.slides.length > 1) {
      this._timeout = setTimeout(
        () =>
          this._showSlide(index < this.props.slides.length - 1 ? index + 1 : 0),
        4000
      )
    }
  }

  componentDidMount() {
    this._showSlide(0)
  }

  componentWillUnmount() {
    clearTimeout(this._timeout)
  }

  render() {
    const slide = this.props.slides[this.state.slide]

    return (
      <>
        <div className={`${styles.slide}  ${styles[slide.className]}`}>
          {slide.icon &&
            <div className={styles.image}>
              {slide.icon}
            </div>
          }
          <div className={styles.text}>{slide.text}</div>
        </div>
        {this.props.slides.length > 1 && (
          <ul className={styles.navigation}>
            {this.props.slides.map((_, index) => (
              <li key={index} onClick={() => this._showSlide(index)}>
                <button
                  className={`${styles.navigationButton} ${index === this.state.slide ? styles.active : ''
                    }`}
                />
              </li>
            ))}
          </ul>
        )}
      </>
    )
  }
}
